var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chemtracker-module"
  }, [_vm.isBusy ? _c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('raft-busy', {
    attrs: {
      "busy-text": "Fetching SDS search results..."
    }
  })], 1) : _c('b-form', [_c('b-container', {
    staticClass: "sds-results-table-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "table",
    staticClass: "sds-search-results",
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "id": "sds-search-results",
      "caption-top": "",
      "caption-html": "Selected SDS and Central Database Options",
      "fields": _vm.fields,
      "items": _vm.sdsSearchResults
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_vm._v("\n            No SDS results found. Select from the attachment options below.\n          ")])];
      }
    }, {
      key: "cell(selected)",
      fn: function (row) {
        return [_c('b-form-group', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.selectedSdsResult,
            expression: "selectedSdsResult"
          }],
          class: 'btn-group-toggle selection-' + row.item.cached_entity_type,
          attrs: {
            "type": "radio",
            "name": 'sds-result-name-' + _vm.getItemUniqueId(row.item),
            "id": 'sds-result-' + _vm.getItemUniqueId(row.item),
            "data-entity-uuid": row.item.cached_entity_uuid,
            "data-entity-type": row.item.cached_entity_type
          },
          domProps: {
            "value": _vm.getItemUniqueId(row.item),
            "checked": _vm._q(_vm.selectedSdsResult, _vm.getItemUniqueId(row.item))
          },
          on: {
            "change": [function ($event) {
              _vm.selectedSdsResult = _vm.getItemUniqueId(row.item);
            }, function ($event) {
              return _vm.setSelectedSdsDocumentId(row.item.id, row.item.cached_entity_uuid, row.item);
            }]
          }
        })])];
      }
    }, {
      key: "cell(view_url)",
      fn: function (row) {
        return [_vm.linkLoading[_vm.getItemUniqueId(row.item)] ? _c('div', {
          staticClass: "text-center text-danger my-2"
        }, [_c('raft-busy', {
          attrs: {
            "busy-text": "Fetching SDS file..."
          }
        })], 1) : _c('div', [row.item.origin === 'external' ? _c('a', {
          attrs: {
            "href": "#",
            "target": "null"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.sdsDownloadFile(row.item);
            }
          }
        }, [_vm._v("View")]) : _c('a', {
          attrs: {
            "href": row.item.url + _vm.getJwt(row.item),
            "target": "_blank"
          }
        }, [_vm._v("View")])])];
      }
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }